// 这个模块仅用于判断是否是PC
export const checkPc = {
	state () {
    return {
      isPc: false 
    }
  },
	mutations: {
    setTrue (state) {
      state.isPc = true
    },

    setFalse (state) {
      state.isPc = false 
    },

    setPc (state, boolVal) {
      if (typeof boolVal === 'boolean') {
        state.isPc = boolVal
      } else {
        throw TypeError(`the incoming param boolVal:${boolVal} is not a boolean`)
      }
    }
	},
	actions: {
    
	},
	getters: {
    isPc: state => state.isPc
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/pc/index.js